@let numberValue = number();

<div class="web-critical-freight-card">
  <div class="web-critical-freight-card__bg-icon">
    @if (numberValue === 1) {
      <fr8bot-ui-icon name="web-progress-01" [size]="{ width: 150, height: 105 }" />
    }
    @if (numberValue === 2) {
      <fr8bot-ui-icon name="web-progress-02" [size]="{ width: 150, height: 105 }" />
    }
    @if (numberValue === 3) {
      <fr8bot-ui-icon name="web-progress-03" [size]="{ width: 150, height: 105 }" />
    }
  </div>

  <div class="web-critical-freight-card__inner">
    <h3 class="web-critical-freight-card__inner-title">{{ title() }}</h3>
    <p class="web-critical-freight-card__inner-description">{{ description() }}</p>
  </div>
</div>
